import { getAnalyticsIdentifier } from 'analytics/';
import { vendorCommandAsync } from 'services/propel';
import { DataDogLogger } from 'utils/dataDog/logger';
import { CARVANA_DEVICE_ID } from 'constants/id';
import { VENDOR_COMMANDS } from 'constants/vendor-commands';
import { AuthenticationStateType } from 'hooks/authentication/types';
import { ConversationStateType } from 'hooks/conversation/types';
import { getUserIdentifier } from 'utils/id';

export type ShowNameMsgAndEscalateDataType = {
  browser_cookie_id: string;
  carvana_browser_cookie_id: string;
  contact_flow_session_id: string;
  form_id: string;
  flow: string;
  twilio_channel_id: string;
};

export const showNameMsgAndEscalate = async (
  authenticationState: AuthenticationStateType,
  conversationState: ConversationStateType,
) => {
  if (!authenticationState.propel.conversationId) {
    console.log('Error: async Twilio conversation not established yet.');
    return;
  }

  const userIdentifier = getUserIdentifier();

  const identifier =
    userIdentifier.userIdentifierType === CARVANA_DEVICE_ID
      ? userIdentifier.carvanaDeviceId
      : userIdentifier.browserCookieId;

  if (!identifier) return;

  const command = VENDOR_COMMANDS.CARVANA_CONTACT_FOLLOW_UP_NAME_SHOW;
  const conversationId = authenticationState.propel.conversationId;
  const twilioConversationSid = conversationState.twilio?.conversation.sid ?? '';
  const analyticsIdentifier = getAnalyticsIdentifier();

  const data: ShowNameMsgAndEscalateDataType = {
    browser_cookie_id: identifier,
    carvana_browser_cookie_id: identifier,
    contact_flow_session_id: analyticsIdentifier,
    form_id: '',
    flow: 'gated_flow',
    twilio_channel_id: twilioConversationSid, // mismatched legacy naming
  };
  try {
    return await vendorCommandAsync(
      conversationId,
      twilioConversationSid,
      command,
      authenticationState.propel.mojoAccessToken,
      data,
    );
  } catch (error) {
    DataDogLogger.error(new Error(`Vendor command from global API failed: ${command}`), {
      conversationId,
      command,
      error,
    });
  }
};
